import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHospital = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-hospital-icon lucide-hospital",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 7v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 9h-4" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 11h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 21V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16" })
	]
});
export default SvgHospital;
